import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Swal from "sweetalert2";

import RateChartModal from "./RateChartModal";
import RateChartServices from "../../../services/RateChartServices";

const RateChartList = () => {

    const activePag = useRef(0);

    // Collapse
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);

    // Loading
    const [loading, setLoading] = useState(false);

    // Table Data
    const [data, setData] = useState([]);

    // Modal
    const [showModal, setShowModal] = useState(false);

    // Filters
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [sort, setSort] = useState(10);

    // Rows Dropdown
    const rowOptions = [
        { value: 5, label: "5" },
        { value: 10, label: "10" },
        { value: 20, label: "20" },
        { value: 50, label: "50" }
    ];

    // Status Dropdown
    const statusOptions = [
        { value: "", label: "All Status" },
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
        { value: "Expired", label: "Expired" }
    ];

    const fetchRateCharts = async () => {

        try {

            setLoading(true);

            const res = await RateChartServices.getAllRateCharts({
                search: searchQuery,
                status: statusFilter,
                limit: sort
            });

            setData(res?.data || []);

        } catch (err) {

            console.error(err);

            Swal.fire(
                "Error",
                err?.response?.data?.message || "Failed to fetch rate charts",
                "error"
            );

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchRateCharts();

    }, []);

    const handleSearch = () => {

        fetchRateCharts();

    };

    const handleReset = () => {

        setSearchQuery("");
        setStatusFilter("");
        setSort(10);

        setTimeout(() => {

            fetchRateCharts();

        }, 100);

    };

    const formatDate = (date) => {

        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-GB");

    };

    const getStatusBadge = (status) => {

        switch (status) {

            case "Approved":
                return (
                    <span className="badge bg-success">
                        Approved
                    </span>
                );

            case "Pending":
                return (
                    <span className="badge bg-warning text-dark">
                        Pending
                    </span>
                );

            case "Rejected":
                return (
                    <span className="badge bg-danger">
                        Rejected
                    </span>
                );

            case "Expired":
                return (
                    <span className="badge bg-secondary">
                        Expired
                    </span>
                );

            default:
                return (
                    <span className="badge bg-light text-dark">
                        {status}
                    </span>
                );
        }

    };
    const handleApprove = async (item) => {

        const { value: expiryDate } = await Swal.fire({
            title: "Approve Rate",
            text: "Please select the expiry date.",
            input: "date",
            inputLabel: "Expiry Date",
            inputAttributes: {
                min: new Date().toISOString().split("T")[0]
            },
            showCancelButton: true,
            confirmButtonText: "Approve",
            cancelButtonText: "Cancel",
            inputValidator: (value) => {
                if (!value) {
                    return "Please select Expiry Date";
                }
            }
        });

        if (!expiryDate) return;

        try {

            await RateChartServices.approveRateChart(
                item._id,
                {
                    expiryDate
                }
            );

            Swal.fire(
                "Success",
                "Rate approved successfully.",
                "success"
            );

            fetchRateCharts();

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message ||
                "Failed to approve rate.",
                "error"
            );

        }

    };

    const handleReject = async (item) => {

        const { value: remarks } = await Swal.fire({
            title: "Reject Rate",
            input: "textarea",
            inputLabel: "Rejection Reason",
            inputPlaceholder: "Enter rejection reason...",
            inputAttributes: {
                rows: 4
            },
            showCancelButton: true,
            confirmButtonText: "Reject",
            confirmButtonColor: "#d33",
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return "Please enter rejection reason.";
                }
            }
        });

        if (!remarks) return;

        try {

            await RateChartServices.rejectRateChart(
                item._id,
                {
                    remarks
                }
            );

            Swal.fire(
                "Rejected",
                "Rate rejected successfully.",
                "success"
            );

            fetchRateCharts();

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message ||
                "Failed to reject rate.",
                "error"
            );

        }

    };

    return (

        <>

            <RateChartModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                onSuccess={fetchRateCharts}
            />

            <div className="row">

                <div className="col-xl-12">
                    {/* ===================== Filter ===================== */}

                    <div className="filter cm-content-box box-primary">

                        <div className="content-title">

                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>
                                Filter
                            </div>

                            <div className="tools">
                                <Link
                                    to="#"
                                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                    onClick={() => setOpen(!open)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>

                        </div>

                        <Collapse in={open}>

                            <div className="cm-content-body form excerpt">

                                <div className="card-body">

                                    <div className="row">

                                        {/* Search */}

                                        <div className="col-xl-4">

                                            <label className="form-label">
                                                Search
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Part No / Description / Supplier"
                                                value={searchQuery}
                                                onChange={(e) =>
                                                    setSearchQuery(e.target.value)
                                                }
                                            />

                                        </div>

                                        {/* Status */}

                                        <div className="col-xl-3">

                                            <label className="form-label">
                                                Status
                                            </label>

                                            <Select
                                                options={statusOptions}
                                                value={
                                                    statusOptions.find(
                                                        x => x.value === statusFilter
                                                    )
                                                }
                                                onChange={(selected) =>
                                                    setStatusFilter(selected.value)
                                                }
                                                className="custom-react-select"
                                                isSearchable={false}
                                            />

                                        </div>

                                        {/* Rows */}

                                        <div className="col-xl-2">

                                            <label className="form-label">
                                                Rows
                                            </label>

                                            <Select
                                                options={rowOptions}
                                                value={
                                                    rowOptions.find(
                                                        x => x.value === sort
                                                    )
                                                }
                                                onChange={(selected) =>
                                                    setSort(selected.value)
                                                }
                                                className="custom-react-select"
                                                isSearchable={false}
                                            />

                                        </div>

                                        {/* Buttons */}

                                        <div
                                            className="col-xl-3 d-flex align-items-end"
                                        >

                                            <button
                                                className="btn btn-primary me-2"
                                                onClick={handleSearch}
                                            >
                                                <i className="fa fa-search me-1"></i>

                                                Search

                                            </button>

                                            <button
                                                className="btn btn-secondary"
                                                onClick={handleReset}
                                            >
                                                <i className="fa fa-refresh me-1"></i>

                                                Reset

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </Collapse>

                    </div>
                    {/* ===================== Rate Chart List ===================== */}

                    <div className="filter cm-content-box box-primary">

                        <div className="content-title d-flex justify-content-between align-items-center">

                            <div className="cpa">

                                <i className="fa fa-list me-2"></i>

                                Rate Chart

                                <span className="badge bg-primary ms-2">
                                    {data.length}
                                </span>

                            </div>

                            <div className="d-flex align-items-center">

                                <i
                                    className="fa fa-plus text-success me-2"
                                    style={{
                                        cursor: "pointer",
                                        fontSize: "16px"
                                    }}
                                    title="New Rate Chart"
                                    onClick={() => setShowModal(true)}
                                ></i>

                                <span
                                    className="me-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowModal(true)}
                                >
                                    New Rate
                                </span>

                                <Link
                                    to="#"
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                    onClick={() => setOpen2(!open2)}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>

                            </div>

                        </div>

                        <Collapse in={open2}>

                            <div className="cm-content-body form excerpt">

                                <div className="card-body">

                                    <div
                                        style={{
                                            overflowX: "auto",
                                            overflowY: "auto",
                                            maxHeight: "500px",
                                            whiteSpace: "nowrap"
                                        }}
                                    >

                                        <table className="table table-bordered table-striped">

                                            <thead
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 2
                                                }}
                                            >

                                                <tr>

                                                    <th>S.No</th>

                                                    <th>Part No</th>

                                                    <th>Description</th>

                                                    <th>Supplier</th>

                                                    <th>Rate</th>
                                                    <th>Mode</th>

                                                    <th>Status</th>

                                                    <th>Expiry Date</th>

                                                    <th>Created By</th>

                                                    <th>Approved By</th>

                                                    <th>Action</th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {loading ? (

                                                    <tr>

                                                        <td
                                                            colSpan="10"
                                                            className="text-center"
                                                        >
                                                            Loading...
                                                        </td>

                                                    </tr>

                                                ) : data.length > 0 ? (

                                                    data.map((item, index) => (

                                                        <tr key={item._id}>

                                                            <td>
                                                                {index + 1}
                                                            </td>

                                                            <td>
                                                                {item?.masterItem?.partNo || "-"}
                                                            </td>

                                                            <td
                                                                className="scrollable-description"
                                                            >
                                                                {item?.masterItem?.description || "-"}
                                                            </td>

                                                            <td>
                                                                {item?.supplier?.name || "-"}
                                                            </td>

                                                            <td>
                                                                ₹ {Number(item?.approvedRate || 0).toFixed(2)}
                                                                {item?.rateUnit?.name
                                                                    ? ` / ${item.rateUnit.name.toUpperCase()}`
                                                                    : ""}
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className={`badge ${item.mode === "PO Creation"
                                                                        ? "bg-primary"
                                                                        : "bg-secondary"
                                                                        }`}
                                                                >
                                                                    {item.mode}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                {getStatusBadge(item.status)}
                                                            </td>

                                                            <td>
                                                                {formatDate(
                                                                    item.expiryDate
                                                                )}
                                                            </td>

                                                            <td>
                                                                {item?.createdBy?.name || "-"}
                                                            </td>

                                                            <td>
                                                                {item?.approvedBy?.name || "-"}
                                                            </td>
                                                            <td>

                                                                {item.status === "Pending" ? (

                                                                    <>
                                                                        <button
                                                                            className="btn btn-success btn-xs me-1"
                                                                            onClick={() => handleApprove(item)}
                                                                        >
                                                                            <i className="fa fa-check"></i>
                                                                        </button>

                                                                        <button
                                                                            className="btn btn-danger btn-xs"
                                                                            onClick={() => handleReject(item)}
                                                                        >
                                                                            <i className="fa fa-times"></i>
                                                                        </button>
                                                                    </>

                                                                ) : item.status === "Approved" ? (

                                                                    <span className="badge bg-success">
                                                                        Approved
                                                                    </span>

                                                                ) : (

                                                                    <span className="badge bg-danger">
                                                                        Rejected
                                                                    </span>

                                                                )}
                                                            </td>

                                                        </tr>

                                                    ))

                                                ) : (

                                                    <tr>

                                                        <td
                                                            colSpan="10"
                                                            className="text-center"
                                                        >
                                                            No Rate Chart Found
                                                        </td>

                                                    </tr>

                                                )}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            </div>

                        </Collapse>

                    </div>
                </div>
            </div>

        </>

    );

};

export default RateChartList;